import { LanguageSelect } from '@/components/LanguageSelect';
import { SupportedLanguage } from '@/utils/types';
import styled from '@emotion/styled';

const StyledLanguageSelect = styled(LanguageSelect)`
    margin-bottom: 16px;
`;

interface Props {
    value: SupportedLanguage;
    onChange: (value: SupportedLanguage) => void;
}

export function CloneVoiceLanguageSelect({ value, onChange }: Props) {
    return <StyledLanguageSelect id="clone-consent-language-select" value={value} onChange={onChange} />;
}
